import { render, staticRenderFns } from "./RadTeamInfo.vue?vue&type=template&id=2b106562&scoped=true"
import script from "./RadTeamInfo.vue?vue&type=script&lang=js"
export * from "./RadTeamInfo.vue?vue&type=script&lang=js"
import style0 from "./RadTeamInfo.vue?vue&type=style&index=0&id=2b106562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b106562",
  null
  
)

export default component.exports